export default __webpack_public_path__ + "static/media/logoDigihapi.cf228906.png";